export enum AccessToken {
  KEY = "AFriDAtEsIstOpEr",
}
